import pick from 'lodash/pick';
export const cleanEntity = (entity) => {
    const keysToKeep = Object.keys(entity).filter(k => !(entity[k] instanceof Object) || (entity[k]['id'] !== '' && entity[k]['id'] !== -1));
    return pick(entity, keysToKeep);
};
export const getEntityFromListById = (id, list) => list.find(item => item.id === id);
